import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class StatusFirebaseService {
  constructor(private afs: AngularFirestore) {}

  getLojaFechada(): Observable<boolean> {
    return this.afs
      .collection<{ status?: boolean }>('Status')
      .doc('status')
      .snapshotChanges()
      .pipe(map(a => a.payload.data()?.status ?? false));
  }
}
